<template>
  <div class="quiz-step__body">
    <div
      class="quiz-options"
      :class="{
        'three': options.length === 3,
        'five': options.length === 5,
        'seven': options.length >= 7,
        'column': isColumn,
        'column-double': isColumn && ((options.length > 4 && withOther) || options.length > 7)
      }"
    >
      <div v-for="(option, i) in options" :key="i" class="quiz-option">
        <input
          :id="`${stepName}_${i}`"
          :name="stepName"
          :value="option.value"
          :type="multiple ? 'checkbox' : 'radio'"
          :checked="selected?.includes(option.value)"
          hidden
        >
        <label :for="`${stepName}_${i}`" @click.prevent="selectOption(option.value)">
          <div v-if="option.img" class="quiz-option__img">
            <img v-if="answer === option.value || selected.includes(option.value)" src="@/assets/img/check.svg" alt="">
            <img v-else :src="`/img/${option.img}.svg`" alt="">
          </div>
          {{ option.label ? option.label : option.value }}
        </label>
      </div>
    </div>
    <div v-if="withOther" class="quiz-other" :class="{ 'column': isColumn }">
      <div class="quiz-input">
        <label for="name">Other</label>
        <input
          v-model="other"
          id="other"
          type="text"
          placeholder="Description"
        >
      </div>
    </div>
    <button v-if="withOther || multiple" class="quiz-btn" type="button" :disabled="!other.length && !selected.length" @click="nextStep()">
      Next
    </button>
  </div>
</template>

<script>
export default {
  emits: ['select'],
  props: {
    stepName: {
      type: String,
      required: true
    },
    isColumn: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    answer: {
      type: [String, Number],
      default: null
    },
    withOther: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      other: '',
      selected: []
    }
  },
  methods: {
    selectOption(val) {
      if (!this.withOther && !this.multiple) {
        this.selected = [val]
        this.$emit('select', val) // Без поля other и не multiple сразу отправляем
      }
      else if (this.selected.includes(val)) this.selected = this.selected.filter(i => i !== val) // Если уже выбран вариант - удаляем его
      else if (this.multiple) this.selected.push(val) // Если multiple и нет - добавляем
      else this.selected = [val]
    },
    nextStep() {
      this.$emit('select', `${this.selected.join(', ')}${this.selected.length && this.other?.length ? ', ' : ''}${this.other}`)
    }
  }
}
</script>